import { render, staticRenderFns } from "./CalibrationsTable.vue?vue&type=template&id=5a8a1da2"
import script from "./CalibrationsTable.vue?vue&type=script&lang=js"
export * from "./CalibrationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports